module.exports = __webpack_public_path__ + "img/306.b22024de.jpg";